import { render } from "./AddBtn.vue?vue&type=template&id=15406a48&scoped=true"
const script = {}

import "./AddBtn.vue?vue&type=style&index=0&id=15406a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15406a48"]])

export default __exports__